export const windowEndError = 'window_end_error';
export const windowPreloadError = 'window_preload_error';
